module.exports = __webpack_public_path__ + "media/flags/tg-3e0d0eca.svg";